import { withDesign } from "@minted/fancyclothes";
import { arrayOf, func, string } from "prop-types";
import { PureComponent } from "react";

@withDesign("DesignProvider")
class ThemeExtractor extends PureComponent {
  render() {
    const { children, getRule, rules, scope } = this.props;

    const currentScopes = this.context.currentScopes;
    let childScope = scope;

    if (scope === "IntroMediumHeadline") {
      currentScopes.push("IntroContainer");
      childScope = "MediumHeadline";
    } else if (scope === "EventSmallHeadline") {
      currentScopes.push("EventContainer");
      childScope = "SmallHeadline";
    }

    const partialDesignObject = rules.reduce((acc, rule) => {
      try {
        acc[rule] = getRule(
          rule,
          childScope,
          this.context.design,
          currentScopes,
        );
      } catch (error) {
        console.error(error);
      }

      return acc;
    }, {});

    return children(partialDesignObject);
  }
}

ThemeExtractor.propTypes = {
  children: func.isRequired,
  rules: arrayOf(string),
  scope: string,
};

export default ThemeExtractor;
